import React from 'react'

import * as s from './LayoutPage.module.scss'

interface IPropsLayoutPage {
  children?: React.ReactNode
  cssVars?: Record<`--${string}`, string>
}

const LayoutPage: React.FC<IPropsLayoutPage> = ({ children, cssVars }) => (
  <div className={s.root} style={cssVars}>
    {children}
  </div>
)

export default LayoutPage
